import cartAddNewAddressHtml from './cartaddnewaddress.component.html';
import './cartaddnewaddress.component.scss';

class CartAddNewAddressController {
    constructor($scope, $http, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;
        
        this.countries = window.countries || ['Polska'];
        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            addressName: '',
            firstName: '',
            lastName: '',
            companyName: '',
            taxNumber: '',
            street: '',
            houseNumber: '',
            flatNumber: '',
            city: '',
            zipCode: '',
            country: 'Polska'
        };

        this.dataValidations = {
            addressName: () => this.data.addressName != '',
            firstName: () => this.type == 0 || this.data.firstName != '',
            lastName: () => this.type == 0 || this.data.lastName != '',
            companyName: () => this.type == 1 || this.data.companyName != '',
            taxNumber: () => this.type == 1 || this.data.taxNumber != '',
            street: () => this.data.street != '',
            houseNumber: () => this.data.houseNumber != '',
            city: () => this.data.city != '',
            zipCode: () => this.data.zipCode != ''
        };
    }

    get isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }
    
        return true;
    }

    $onInit() {
        this.data.type = parseInt(this.type);

        if (this.data.type == 1) {
            this.data.country = this.country;
        }
    }

    save() {
        this.showAllErrors = true;

        if (!this.isValid) return;

        this.loading = true;

        this.$http.post(
            '/ajax/checkout/add-new-address',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                const id = response.data.data.addressId;

                this.$scope.$parent.$ctrl.close({id, data: this.data});
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let cartAddNewAddressComponent = {
    bindings: {
        type: '<',
        country: '@'
    },
    template: cartAddNewAddressHtml,
    controller: CartAddNewAddressController
}

export default cartAddNewAddressComponent;